import React, { useEffect } from "react";
import PageShell from "../components/PageShell";

const Terms = () => {
  useEffect(() => {
    document.title = "Terms of Use — topastrologerinindia.com";
  }, []);
  return (
    <PageShell title="Terms of Use" subtitle="Effective from July 2025. Last updated June 2026.">
      <p className="text-[15px] leading-relaxed text-slate-700">
        Welcome to topastrologerinindia.com. By accessing or using this website you agree to be
        bound by these Terms of Use. If you do not agree with any part of these terms, please do
        not use the website.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">1. About this website</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        topastrologerinindia.com is an independent editorial platform that publishes a ranked
        list of trusted astrologers in India. We are <strong>not</strong> an astrologer ourselves;
        we list and review independent astrologers who offer paid consultations via WhatsApp,
        phone or video.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">2. Nature of content</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        All astrology-related content on this website is provided for <strong>entertainment and
        personal guidance purposes only</strong>. Astrology is not a substitute for professional
        medical, legal, financial, psychological or other expert advice. Decisions you make based
        on any astrologer's reading are your own responsibility.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">3. Third-party astrologers</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        Each astrologer listed on this site is an independent professional. When you tap a
        WhatsApp button you are sent to WhatsApp to chat with that astrologer directly. Any
        agreement, payment, or refund is between you and the astrologer. topastrologerinindia.com
        is not party to that transaction and does not earn a commission from any consultation.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">4. Editorial independence</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        Rankings are based on the editorial team's evaluation of years of experience, depth of
        expertise across systems (Vedic, KP, Nadi, Tarot, Vastu), verified consultation count,
        and client feedback. The ranking is editorial opinion, not a guarantee of accuracy of any
        individual reading.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">5. Acceptable use</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        You agree not to use this website for any unlawful purpose, to scrape data for resale, to
        impersonate any astrologer listed, or to abuse the WhatsApp contact links.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">6. Intellectual property</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        Editorial content, design and rankings on this website are the property of
        topastrologerinindia.com. Astrologer names and brand marks remain the property of their
        respective owners.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">7. Limitation of liability</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        To the maximum extent permitted by law, topastrologerinindia.com shall not be liable for
        any direct, indirect, incidental or consequential damages arising from your use of this
        website or from any consultation booked through it.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">8. Governing law</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        These terms are governed by the laws of India. Any dispute arising out of these terms
        shall be subject to the exclusive jurisdiction of the courts at New Delhi, India.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">9. Contact</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        Email: <a href="mailto:sachinsharma6886@gmail.com" className="text-[#16a3a8] font-semibold">sachinsharma6886@gmail.com</a>
      </p>
    </PageShell>
  );
};

export default Terms;
